import React from 'react';
import {
  RequestFormVisibility,
  useRequestFormsForManagerQuery,
} from '../../../__generated__/graphql';
import { RequestForm } from '../RequestForm';
import { RequestFormProps } from '../RequestForm/types';
import { isSelectableInNewRequest } from '../isSelectableInNewRequest';

export const ManagerRequestForm: React.FC<
  React.PropsWithChildren<RequestFormProps>
> = (props) => {
  const { data, loading } = useRequestFormsForManagerQuery({
    skip: !props.show,
  });

  const requestFormsVisibleForManager =
    data?.requestForms.filter(
      (form) =>
        (form.flair__Visibility__c ===
          RequestFormVisibility.HrManagerEmployee ||
          form.flair__Visibility__c === RequestFormVisibility.HrManager) &&
        isSelectableInNewRequest(form),
    ) ?? [];

  return (
    <RequestForm
      {...props}
      requestForms={requestFormsVisibleForManager}
      employees={data?.manager?.employees ?? []}
      isSelectEmployeeStepVisible={true}
      loading={loading}
    />
  );
};
